import { FC, ReactNode } from 'react';
import { Popover as RadixPopover } from 'radix-ui';

import { BottomSheet } from '../../../BottomSheet';
import { useMedia } from '../../../useMedia';
import { DESKTOP_QUERY } from '../../model/query';

import styles from './PickerShell.module.css';

export type PickerShellProps = {
  trigger: ReactNode;
  calendar: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/** Не даёт Radix перехватить фокус у поля ввода триггера, пока пользователь печатает дату. */
const preserveTriggerInputFocus = (event: Event) => {
  if (document.activeElement instanceof HTMLInputElement) {
    event.preventDefault();
  }
};

/** Общая обвязка: поповер на десктопе, шторка снизу на мобайле. */
const PickerShell: FC<PickerShellProps> = ({ trigger, calendar, open, onOpenChange }) => {
  const isDesktop = useMedia(DESKTOP_QUERY);

  if (isDesktop) {
    return (
      <RadixPopover.Root
        open={open}
        onOpenChange={onOpenChange}>
        <RadixPopover.Anchor asChild>{trigger}</RadixPopover.Anchor>
        <RadixPopover.Portal>
          <RadixPopover.Content
            sideOffset={8}
            align="start"
            onOpenAutoFocus={preserveTriggerInputFocus}
            onInteractOutside={preserveTriggerInputFocus}
            className={styles.popoverContent}>
            {calendar}
          </RadixPopover.Content>
        </RadixPopover.Portal>
      </RadixPopover.Root>
    );
  }

  return (
    <>
      {trigger}
      <BottomSheet
        open={open}
        onOpenChange={onOpenChange}
        contentClassName={styles.bottomSheetContent}>
        <BottomSheet.Body className={styles.bottomSheetBody}>{calendar}</BottomSheet.Body>
      </BottomSheet>
    </>
  );
};

export default PickerShell;
